import { call, put, select, takeLatest, all, delay } from 'redux-saga/effects';
import Action from '../action';
import InvoiceApi from '../../Api/inoviceApi';
import {
  setProgressBar,
  setSnackBar,
  closeSnackBar,
  setDialog,
  movePage,
  setMenuType,
  getCode,
  initCheckElement,
  initInvoice,
  initState,
  getInvoice,
  getInvoiceTemp,
  getInvoicePos,
  getInvoiceList,
  getInvoicePosList,
  setInvoiceList,
  getInvoiceListTotalAmout,
  getInvoicePosListTotalAmout,
  getIssueInvoiceDetail,
  objectStorageDownload,
} from './Common';
import { getInvoiceTempList } from './Inquiry';
import taker from './taker';

/**
 * [Issuance] Invoice Issue(발급)
 */
export function* setInvoiceIssue({ payload }) {
  const response = yield call(InvoiceApi.setInvoiceIssue, payload);
  if (response.status === 200) {
    // yield put(Action.invoiceIssueInfo.success(response.data.content[0]));
    yield put(Action.invoiceIssueInfo.success(response.data));
    yield put(Action.invoiceCheckIssuePopup.success(false));
    yield put(Action.isInvoiceInit.success(true));
    yield put(Action.invoiceIssueCompletePopup.success(true));
  } else if (response.status === 204) {
    yield call(setDialog, {
      payload: {
        open: true,
        useIcon: false,
        title: 'non-existent taxpayer',
        message: 'non-existent taxpayer',
        closeLabel: 'Confirm',
      },
    });
  }
}

export function* setPreviewInvoiceIssue({ payload }) {
  const response = yield call(InvoiceApi.setInvoiceIssue, payload);
  if (response.status === 200) {
    // yield put(Action.invoiceIssueInfo.success(response.data.content[0]));
    yield put(Action.invoiceIssueInfo.success(response.data));
    yield put(Action.isInvoiceInit.success(true));
    yield put(Action.invoicePreviewPopup.success(false));
    yield put(Action.invoiceIssueCompletePopup.success(true));
  } else if (response.status === 204) {
    yield call(setDialog, {
      payload: {
        open: true,
        useIcon: false,
        title: 'non-existent taxpayer',
        message: 'non-existent taxpayer',
        closeLabel: 'Confirm',
      },
    });
  }
}

export function* setInvoiceSave({ payload }) {
  const response = yield call(
    InvoiceApi.setInvoiceTempList,
    payload.invoiceTempDtoList
  );
  if (response.status == 200) {
    yield put(Action.invoiceSavePopup.success(false));
    yield put(Action.isInvoiceInit.success(true));
    yield put(Action.invoiceSaveCompletePopup.success(true));
  } else if (response.status == 204) {
    yield call(setDialog, {
      payload: {
        open: true,
        useIcon: false,
        title: 'non-existent taxpayer',
        message: 'non-existent taxpayer',
        closeLabel: 'Confirm',
      },
    });
  } else if (payload.type == 'mass' && response.status == 404) {
    yield call(setDialog, {
      payload: {
        open: true,
        useIcon: false,
        title: 'Check Excel upload format',
        message: ['Check Excel upload format.', <br />, 'Missed "START".'],
        closeLabel: 'Confirm',
      },
    });
  }
}

/**
 * [Issuance] Invoice Issue Check poup
 */
export function* invoiceCheckIssuePopup({ payload }) {
  if (payload.invoiceCheckIssuePopup) {
    // const checkResponse = yield call(companyApi.isTin, { tin: payload.tin });
    // if (checkResponse.status !== 200) {
    //   yield call(setDialog, {
    //     payload: {
    //       open: true,
    //       message: 'already TIN is exist.',
    //       closeLabel: 'confirm',
    //     },
    //   });
    //   return;
    // }
    yield put(
      Action.invoiceCheckIssuePopup.success(payload.invoiceCheckIssuePopup)
    );
  } else {
    yield put(
      Action.invoiceCheckIssuePopup.success(payload.invoiceCheckIssuePopup)
    );
  }
}

/**
 * [Issuance] Invoice Save Complete poup
 */
export function* invoicePreviewPopup({ payload }) {
  yield put(Action.invoicePreviewPopup.success(payload));
}

/**
 * [Issuance] Invoice Save Check poup
 */
export function* invoiceSavePopup({ payload }) {
  if (payload.invoiceSavePopup) {
    // 나중에 Tin이 유효한지 안한지 로직 적용 필요 >> 내부 로직
    let isTin = true;
    if (!isTin) {
      yield call(setDialog, {
        payload: {
          open: true,
          message: 'Invalid TIN.',
          closeLabel: 'confirm',
        },
      });
      return;
    }
    yield put(Action.invoiceSavePopup.success(payload.invoiceSavePopup));
  } else {
    yield put(Action.invoiceSavePopup.success(payload.invoiceSavePopup));
  }
}

/**
 * [Issuance] Invoice Save Complete poup
 */
export function* invoiceSaveCompletePopup({ payload }) {
  yield put(Action.invoiceSaveCompletePopup.success(payload));
}

/**
 * [Issuance] Invoice Issue Complete poup
 */
export function* invoiceIssueCompletePopup({ payload }) {
  yield put(Action.invoiceIssueCompletePopup.success(payload));
}

/**
 * [Issuance] Invoice Issue Date init ?
 */
export function* isInvoiceInit({ payload }) {
  yield put(Action.isInvoiceInit.success(payload));
}

export function* getMassiveIssuanceVerificationResult({ payload }) {
  let massiveIssuanceVerificationResultList;
  const response = yield call(
    InvoiceApi.getMassiveIssuanceVerificationResult,
    payload
  );

  if (response.status === 200) {
    massiveIssuanceVerificationResultList = response.data;
    yield put(
      Action.getMassiveIssuanceVerificationResult.success(
        massiveIssuanceVerificationResultList
      )
    );
  }
}

export function* updateMassiveIssuance({ payload }) {
  try {
    const response = yield call(
      InvoiceApi.updateMassiveIssuance,
      payload.invoiceNoList
    );

    if (response.status === 200) {
      yield call(setDialog, {
        payload: {
          open: true,
          message: 'Requested Massive Issuance',
          closeLabel: 'OK',
        },
      });
      // searchData 있을때 만 재조회
      if (payload.searchData) {
        yield call(getInvoiceTempList, { payload: payload.searchData });
      }
      return;
    } else {
      yield call(setDialog, {
        payload: {
          open: true,
          message: 'Failed Request Massive Issuance',
          closeLabel: 'confirm',
        },
      });
      return;
    }
  } catch (e) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Error occurred',
        closeLabel: 'confirm',
      },
    });
  } finally {
  }
}

/**
 * setMassiveInvoiceTempList
 */
export function* setMassiveInvoiceTempList({ payload }) {
  yield put(Action.setInvoiceList.success(payload));
}

export default [
  takeLatest(Action.setInvoiceIssue.TRIGGER, taker(setInvoiceIssue)),
  takeLatest(
    Action.setPreviewInvoiceIssue.TRIGGER,
    taker(setPreviewInvoiceIssue)
  ),
  takeLatest(Action.setInvoiceSave.TRIGGER, taker(setInvoiceSave)),
  takeLatest(
    Action.invoiceCheckIssuePopup.TRIGGER,
    taker(invoiceCheckIssuePopup)
  ),
  takeLatest(Action.invoicePreviewPopup.TRIGGER, taker(invoicePreviewPopup)),
  takeLatest(Action.invoiceSavePopup.TRIGGER, taker(invoiceSavePopup)),
  takeLatest(
    Action.invoiceSaveCompletePopup.TRIGGER,
    taker(invoiceSaveCompletePopup)
  ),
  takeLatest(
    Action.invoiceIssueCompletePopup.TRIGGER,
    taker(invoiceIssueCompletePopup)
  ),
  takeLatest(Action.isInvoiceInit.TRIGGER, taker(isInvoiceInit)),
  takeLatest(
    Action.getMassiveIssuanceVerificationResult.TRIGGER,
    taker(getMassiveIssuanceVerificationResult)
  ),
  takeLatest(
    Action.updateMassiveIssuance.TRIGGER,
    taker(updateMassiveIssuance)
  ),
  takeLatest(
    Action.setMassiveInvoiceTempList.TRIGGER,
    taker(setMassiveInvoiceTempList)
  ),
];
